import { createTranslations } from '@npco/utils-translations'

export const useFormValidationTranslations = createTranslations({
  emailRequired: 'Please enter an Email',
  mobileNumberRequired: 'Please enter a Mobile Number',
  invalidEmail: 'Please enter a valid Email',
  invalidMobileNumber: 'Please enter a valid Mobile Number',
})
